import { base64ToArrayBuffer } from 'features/e2ee/utils/base64';
import { e2eeDecrypt } from 'features/e2ee/utils/e2eeDecrypt';

export const base64Decrypt = async (data: string, key: CryptoKey) =>
  base64ToArrayBuffer(await e2eeDecrypt(data, key));
